import { OrganizationInput, ReferenceInput } from 'sr-types/lib/organization/v1/graphql';

import { ReferenceField } from '../common/reference/reference';
import { failedToastMessage, successToastMessage } from '../common/utils/commonUtils';
import { Contact } from '../common/components/types';

type AddOptionValue = {
    label: string;
    createOption: boolean;
};
export type QuickAddOrganization = {
    id: string;
    name: string;
    parentOrganizationName: string;
    organizationTypes: Array<string>;
    reference: ReferenceField;
    contact?: Contact;
};

export type QuickAddOrganizationInput = {
    id: string;
    label: string;
    parentOrganizationName: string;
    organizationTypes: Array<string>;
    ref: ReferenceInput;
};

export const getOption = (item: QuickAddOrganization): QuickAddOrganizationInput => {
    return {
        id: item.id,
        label: item.name,
        parentOrganizationName: item.parentOrganizationName,
        organizationTypes: item.organizationTypes,
        ref: { ...item.reference, label: item.name }
    };
};

export const quickAddOrganization = (
    value: AddOptionValue,
    save: (value) => Promise<any>,
    customSavedEntity?: OrganizationInput
): Promise<any> => {
    return new Promise((resolve, reject) => {
        const savedEntity = {
            publicName: value?.label,
            summary: { about: '', headline: '' },
            ...(customSavedEntity || {})
        };
        save({
            variables: {
                input: savedEntity
            }
        })
            .then((res) => {
                if (res.data.autoCreateOrganization.errors) {
                    failedToastMessage('form.save.failure', { name: savedEntity.publicName });
                } else {
                    successToastMessage('form.save.success', { name: savedEntity.publicName });
                    const { autoCreateOrganization } = res.data;
                    autoCreateOrganization.reference.label = savedEntity.publicName;
                    const organizationReference = {
                        id: autoCreateOrganization.id,
                        label: savedEntity.publicName,
                        ref: autoCreateOrganization.reference
                    };
                    resolve(organizationReference);
                }
            })
            .catch((err) => {
                failedToastMessage('form.save.failure', { name: savedEntity.publicName });
                reject(err);
            });
    });
};
